export default {
    PtWorkspaceFolderTree: {
        noData: '対応するフォルダが見つかりません',
        myWorkspace: '私のワークスペース',
        sharedWorkspace: '共有のワークスペースから',
        publicWorkspace: '企業ワークスペース',
        noFolder: 'このワークスペースにはフォルダがありません。ほかのワークスペースを選択してみてください。',
    },
};
